module.exports = __webpack_public_path__ + "img/arrow-right-white.8804decb.svg";